
import Vue, {PropType} from "vue";
import {ExcelProductModel} from "kistenkonfigurator/build/excel/ExcelProductModel";
import {ConfigurationDataFlat} from "kistenkonfigurator/build/property/configuration";
import {AlternateRenderingPropertyRoot} from "kistenkonfigurator/build/product/AlternateRenderingProductModel";
import {ProductModelFactory} from "../../../model/product/ProductModelFactory";
import {FlatProductConfigurations, ProductConfiguratorUIModel} from "../../../model/ProductBusinessLogic";
import {Product} from "../../../model/rest/data-contracts";
import type {ProductCreatedEvent} from "./CreateProductModal.vue";

export interface ConfigurationChangedEvent {
  userConfiguration: ConfigurationDataFlat;
  configuratorConfiguration: FlatProductConfigurations;
  productModel: ExcelProductModel;
  productImageUrl: string;
  quantity: number;
}

interface State {
  product: Product;
  productConfiguratorModel: ProductConfiguratorUIModel;
}

export default Vue.extend({
  components: {
    ProductConfigurator: () => import("../../../components/configurator/ProductConfigurator.vue"),
  },
  props: {
    canCreateProduct: {
      type: Boolean,
      default: false,
    },
    /**
     * See ProductConfigurator.vue#canBeConfigured
     */
    canBeConfigured: {
      type: Boolean,
      default: true,
    },
    /**
     * See ProductConfigurator.vue#showAmountAndPrice
     */
    showAmountAndPrice: {
      type: Boolean,
      default: true,
    },
    propertyRoot: {
      type: String as PropType<AlternateRenderingPropertyRoot>,
      required: true,
    },
    quantity: {
      type: Number,
      default: 1,
    },
    customerId: {
      type: Number,
      default: undefined,
    },
  },
  data(): State {
    return {
      product: ProductModelFactory.createEmptyOverviewProduct(),
      productConfiguratorModel: {
        configuratorConfiguration: {
          productConfiguration: {},
          completeConfiguration: {},
        },
        configuration: {},
      },
    };
  },
  computed: {
    viewOnly(): boolean {
      return !this.canBeConfigured && !this.showAmountAndPrice;
    },
  },
  methods: {
    onProductCreated(event: ProductCreatedEvent) {
      this.$emit("onProductCreated", event);
      this.cancelClicked();
    },
    dialog(): any {
      return this.$refs.dialog as any;
    },
    configurator(): any {
      return this.$refs.configurator as any;
    },
    /**
     * @param {Product} product
     * @param {ConfigurationDataFlat} configuration
     */
    open(product: Product, configuration: ConfigurationDataFlat): void {
      this.product = product;
      this.productConfiguratorModel = {
        configuration,
        configuratorConfiguration: {
          productConfiguration: {},
          completeConfiguration: {},
        },
      };
      this.dialog().show();
    },
    async okClicked(): Promise<void> {
      const imageData = await this.configurator().generateProductImage();

      const quantity = this.configurator().getQuantityAsInt();

      const productModel = this.configurator().getCurrentProductModel();
      const event: ConfigurationChangedEvent = {
        userConfiguration: this.productConfiguratorModel.configuration,
        configuratorConfiguration: this.productConfiguratorModel.configuratorConfiguration,
        productModel,
        productImageUrl: imageData,
        quantity,
      };

      this.$emit("onConfigurationChanged", event);
      this.cancelClicked();
    },
    cancelClicked(): void {
      this.dialog().hide();
      this.closeClicked();
    },
    closeClicked() {
      this.product = ProductModelFactory.createEmptyOverviewProduct();
      this.productConfiguratorModel = {
        configuratorConfiguration: {
          productConfiguration: {},
          completeConfiguration: {},
        },
        configuration: {},
      };
    },
  },
});
